// extracted by mini-css-extract-plugin
export var animation = "homepageImageText-module--animation--KXTxz";
export var firstImage = "homepageImageText-module--firstImage--M-JEf";
export var sbShowMain = "homepageImageText-module--sb-show-main--2upqo";
export var title = "homepageImageText-module--title--gLBVR";
export var trigger = "homepageImageText-module--trigger--83Z9z";
export var wrapper = "homepageImageText-module--wrapper--YiA26";